import { useState } from 'react';
export default function ServiceCard({ id, image, title, description, price, onMoreInfoClick }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleCardClick = () => {
    onMoreInfoClick(id);
  };

  const handleRegisterClick = (e) => {
    e.stopPropagation();
    onMoreInfoClick(id);
  };

  const toggleReadMore = (e) => {
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  const maxLength = 90;
  const isLongDescription = description.length > maxLength;

  return (
    <div 
      onClick={handleCardClick}
      className="bg-white rounded-2xl border border-slate-300 transition-all duration-300 group flex flex-col hover:-translate-y-1 hover:border-gray-300 cursor-pointer h-full"
    >
      <img
        src={image}
        alt={title}
        className="w-full h-40 object-cover rounded-t-2xl"
      />
      <div className="p-6 pt-6 flex flex-col flex-grow">
        <h3 className="text-sm font-semibold text-center text-gray-900 mb-3">
          {title}
        </h3>
        <p className="text-gray-500 text-sm leading-relaxed font-medium text-justify">
          {isExpanded ? description : (isLongDescription ? `${description.slice(0, maxLength)} ` : description)}
          {!isExpanded && isLongDescription && (
            <span 
              onClick={toggleReadMore} 
              className="text-orange-500 hover:text-orange-600 cursor-pointer font-bold whitespace-nowrap"
            >
              View More
            </span>
          )}
          {isExpanded && isLongDescription && (
            <span 
              onClick={toggleReadMore} 
              className="text-orange-500 hover:text-orange-600 cursor-pointer font-bold whitespace-nowrap ml-1"
            >
              View Less
            </span>
          )}
        </p>
        <div className="mt-auto pt-4 text-right">
          <button
            onClick={handleRegisterClick}
            className="inline-flex items-center justify-center rounded-lg w-full min-h-[40px] text-sm font-semibold bg-orange-500 text-white hover:bg-orange-600 transition-colors"
          >
            Register Service
          </button>
        </div>
      </div>
    </div>
  );
}